import { format, addMinutes, startOfDay } from 'date-fns';

const HOURS_PER_DAY = 24;
const INTERVAL_IN_MINUTES = 5;
const INTERVALS_PER_HOUR = 60 / INTERVAL_IN_MINUTES;

export const getTimes = intl => {
  let runningDate = startOfDay(new Date());
  const maxIterations = HOURS_PER_DAY * INTERVALS_PER_HOUR;
  const times = [];

  for (let i = 0; i < maxIterations; i += 1) {
    const label = intl.formatDate(runningDate, { format: 'time' });
    const value = format(runningDate, 'HH:mm');
    times.push({
      label,
      value,
      match: label,
    });
    runningDate = addMinutes(runningDate, INTERVAL_IN_MINUTES);
  }
  return times;
};
